import React, {useEffect} from "react";
import './AnalizaMain.css';
import MathJax from 'react-mathjax-preview';
import {useHistory} from "react-router-dom";
import * as BiIcons from "react-icons/bi";

export default function DwumianNewtona(){

    useEffect(()=>{
        document.title="Dwumian Newtona";
    },[])

    const { push } = useHistory();

    const comeBackFunc=()=>{
        push('/analiza/pojecia-wstepne');
    }

    return(
        <div className='conceptsContainer'>
            <div className='comeBackDiv' onClick={comeBackFunc}>
                <BiIcons.BiArrowBack/>
                <div style={{textAlign: 'left', alignItems: 'left'}}>Cofnij</div>
            </div>

            <h1>Dwumian Newtona</h1>

            <p>Dwumianem Newtona nazywamy wzór na n-tą potęgę a+b.</p>
            <MathJax math={'`(a+b)^n=((n),(0))a^nb^0+((n),(1))a^(n-1)b^1+((n),(2))a^(n-2)b^2+' +
            '...+((n),(n-2))a^2b^(n-2)+((n),(n-1))a^1b^(n-1)+((n),(n))a^0b^n`'}/>
            <p className='oneLine centerVertical'>W tym wzorze używamy symbolu &nbsp;
                {/*(&nbsp<div className='column'><sup>n</sup> k</div>&nbsp;)*/}
                <MathJax math={'`((n),(k))`'}/> &nbsp; i jest on określony następująco:
            </p>
            <p className='oneLine centerVertical'>{/*(&nbsp;<div className='column'><sup>n</sup> k</div>&nbsp;) =
                <div className='column'><sup>n!</sup> <hr className='dwumianOgol'/> <sub>k!(n-k)!</sub></div>*/}
                <MathJax math={'`((n),(k)) = (n!)/(k!(n-k))`'}/>
            </p>

            <p>Symbol ! - oznacza silnię, czyli iloczyn wszystkich liczb naturalnych nie większych od liczby, na której działamy.</p>
            <br/><br/>

            <p>Przykład:</p>
            {/*<p className='oneLine centerVertical'>(&nbsp;<div className='column'><sup>n</sup> 1</div>&nbsp;) = n</p>*/}
            <MathJax math={'`((n),(1)) = n`'}/><br/>
            {/*<p className='oneLine centerVertical'>(&nbsp;<div className='column'><sup>n</sup> 3</div>&nbsp;) =
                <div className='column'><sup>n(n-1)(n-2)</sup> <hr className='dwumianOgol'/> <sub>1 &#8901; 2 &#8901; 3</sub></div>
            </p>*/}
            <MathJax math={'`((n),(3)) = (n(n-1)(n-2))/(1cdot2cdot3)`'}/>

            <br/><br/>

            <p>Przykład:</p>
            <p className='oneLine centerVertical'>1)&nbsp;&nbsp;<MathJax math={'`(a+b)^4`'}/></p>
            <MathJax math={'`(a+b)^4=((4),(0))x^4+((4),(1))x^3y+((4),(2))x^2y^2+((4),(3))xy^3+((4),(4))y^4=x^4+3x^3y+6x^2y^2+4xy^3+y^4`'}/>
            <br/><br/>

            <p className='oneLine centerVertical'>2)&nbsp;&nbsp;Oblicz trzeci wyraz rozwinięcia: <MathJax math={'`(a+b)^6`'}/></p>
            <p>Trzeci wyraz będzie równy: </p>
            <p className='oneLine centerVertical'>
                <MathJax math={'`((6),(2)) cdot a^(6-2) cdot b^2 = 90 cdot a^4 cdot b^2`'}/>
            </p>
            <br/><br/>

        </div>
    );
}